export default __webpack_public_path__ + "static/media/card-bottom3.4ccade91.webp";